import React from "react";
import "./index.css";

const Header = () => {
    return (
        <div className="header-container">
        <h1 className="heading">VSM Bill Payment System</h1>
        <h4 className="heading">Bharat Connect supports payments and collections for the following list of services.</h4>
        </div>
        )
    };

export default Header;